import '../Table/style.scss'
import React, { useState, useEffect } from 'react'
import DataTable from 'react-data-table-component';
import { customStyles } from '../Table/style'
import helpers from 'src/utils/helpers';
import { NoTableData } from 'src/component';

export const ServerSideTable: React.FC<any> = React.memo(({
    tableData, tableColumns, resetPagination, 
    hasRowSelection, onRowSelectedMethod,
    onRowClickMethod, noDataText, paginationPerPage, 
    noDataCustomIcon, actionComponent, pageNumber,
    dataFetchMethod, totalRows, callOnMount,
    shouldResetPagination
}) => {
    const [mockTableData, setMockTableData] = useState<any[]>([])
    const [perPage, setPerPage] = useState(10);
    const [currentPage, setCurrentPage] = useState(pageNumber || 1);

    useEffect(() =>{
        if (callOnMount) dataFetchMethod(pageNumber, perPage)
    }, [])
  
    useEffect(() => {
        setCurrentPage(1)
    }, [pageNumber, shouldResetPagination])
  
    useEffect(() => {
        setMockTableData(tableData)
    }, [tableData])
  
    // function handleDataSearching (e: React.ChangeEvent<HTMLInputElement>) {
    //     const filteredData = helpers.searchTableData(tableData, e.target.value)
    //     setMockTableData(filteredData)
    // }
  
    const handlePageChange = (page: any) => {
        dataFetchMethod(page, perPage);
        setCurrentPage(page);
    };
  
    const handlePerRowsChange = async (newPerPage: React.SetStateAction<number>, page: any) => {
        dataFetchMethod(page, newPerPage);
        setPerPage(newPerPage);
    };


    return (
        <>
        { tableData ?
                <>
                    <div>
                        <DataTable
                            columns={tableColumns}
                            data={mockTableData?.length ? mockTableData : tableData}
                            paginationResetDefaultPage={resetPagination}
                            //striped={true}
                            onRowClicked={onRowClickMethod}
                            // selectableRows={hasRowSelection}
                            // onSelectedRowsChange={hasRowSelection ? onRowSelectedMethod : null}
                            pagination
                            paginationServer
                            paginationTotalRows={totalRows}
                            //paginationPerPage={paginationPerPage || 10}
                            paginationDefaultPage={currentPage}
                            onChangeRowsPerPage={handlePerRowsChange}
                            onChangePage={handlePageChange}
                            customStyles={customStyles}
                            noDataComponent={
                                <NoTableData 
                                    noDataText={noDataText} 
                                    actionComponent={actionComponent} 
                                    noDataCustomIcon={noDataCustomIcon}
                                />
                            }
                        />
                    </div>
                </>
                : 
                <NoTableData 
                    noDataText={noDataText} 
                    actionComponent={actionComponent}
                    noDataCustomIcon={noDataCustomIcon}
                />
            }
        </>
    )
})